<template>
  <div class="coming-soon" ref="container">
    <div class="sparkle star1"></div>
    <div class="sparkle star2"></div>
    <div class="sparkle star3"></div>
    <div class="sparkle star4"></div>
    <div class="sparkle star5"></div>
    <h1 ref="title">COMING SOON</h1>
    <h2 ref="subtitle">
      <span
        v-for="(char, index) in splitTitle"
        :key="index"
        class="char"
        :style="{ display: char === ' ' ? 'inline-block' : 'inline' }"
      >
        {{ char }}
      </span>
    </h2>
    <p ref="message">We're launching something awesome. Stay tuned!</p>
  </div>
</template>

<script setup>
//https://colorhunt.co/palette/3334467f8caab8cfceeaefef
import { ref, onMounted, nextTick } from "vue";
import gsap from "gsap";

const container = ref(null);
const subtitle = ref(null);
const message = ref(null);

const rawTitle = "Venny Luise Group";
const splitTitle = rawTitle.split("");

onMounted(async () => {
  await nextTick(); // wait for DOM to update

  const chars = subtitle.value.querySelectorAll(".char");

  gsap.from(chars, {
    opacity: 0,
    y: -20,
    stagger: 0.05,
    duration: 0.6,
    ease: "power2.out",
  });

  gsap.from(message.value, {
    opacity: 0,
    y: 20,
    duration: 1,
    delay: 0.6,
  });

  gsap.from(container.value, {
    scale: 0.95,
    opacity: 0,
    duration: 1,
    delay: 0.2,
  });
});
</script>

<style scoped>
.coming-soon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f2efea, #ffffff);
  color: white;
  text-align: center;
  padding: 2rem;
  font-family: "Cinzel", serif;
}

h1 {
  font-size: 3.5rem;
  margin-bottom: 0.5rem;
  color: #9a7449;
  font-weight: 400;
}

h2 {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #9a7449;
}

p {
  font-size: 1rem;
  margin-bottom: 2rem;
  color: #9a7449;
}

.char {
  display: inline-block;
  white-space: pre; /* keep spaces visible */
}

.sparkle {
  position: absolute;
  width: 20px;
  height: 20px;
  background: transparent;
  opacity: 0.5;
}

.star1 {
  top: 10vh;
  left: 15vw;
  animation: twinkle 2s infinite;
}

.star2 {
  top: 70vh;
  left: 65vw;
  animation: twinkle 3s infinite;
}
.star3 {
  top: 14vh;
  left: 92vw;
  animation: twinkle2 2s infinite;
}
.star4 {
  top: 82vh;
  left: 26vw;
  animation: twinkle 2.5s infinite;
}
.star5 {
  top: 25vh;
  left: 42vw;
  animation: twinkle2 2s infinite;
}
.sparkle::before,
.sparkle::after {
  content: "";
  position: absolute;
  background: #9a7449;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 2px;
  box-shadow: 0 0 6px rgba(255, 255, 255, 0.8);
}

@keyframes twinkle {
  0%,
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 0.5;
    transform: translate(-50%, -50%) scale(1.2);
  }
}

@keyframes twinkle2 {
  0%,
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 0.5;
    transform: translate(-50%, -50%) scale(1.5);
  }
}

.sparkle::before {
  width: 2px;
  height: 20px;
}

.sparkle::after {
  width: 20px;
  height: 2px;
}
</style>
